import React, { useCallback, useEffect, useState } from "react"
import TopCategoryOuter from "../TopCategoryOuter"
import * as wjcCore from "@grapecity/wijmo"
import _ from "lodash"
import { TLoginUserInfo } from "../../../service/auth/TAuth"
import DashboardService from "../../../service/dashboard/dashboardService"
import { T部所売上額 } from "../../../service/dashboard/TDashboard"
import { BusyoUriagegakuGrid } from "./BusyoUriagegakuGrid"
import ComboBox from "../../../components/ComboBox"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import { TWijmoComboBox } from "../../../type/wijmoComponents"
import BusyoService from "../../../service/master/busyo/busyoService"
import { useSelector } from "react-redux"
import { RootState } from "../../../globalStore/rootreducer"
import Decimal from "decimal.js"
import { BusyoUriagegakuGage } from "./BusyoUriagegakuGage"
import dayjs from "dayjs"

export type T部所売上額集計値 = {
  予算額: number
  当年実績: number
  乗務員売上: number
  前年実績: number
  達成率?: number
  前年比?: number
}

export const create部所売上集計 = (
  orgList: T部所売上額[],
  部所コード: string | undefined | null
) => {
  let 集計Obj: T部所売上額集計値 | null | undefined

  if (wjcCore.isNullOrWhiteSpace(部所コード ?? "")) {
    集計Obj = {
      予算額: _.sumBy(orgList, (n) => n.予算額 ?? 0),
      当年実績: _.sumBy(orgList, (n) => n.当年実績 ?? 0),
      乗務員売上: _.sumBy(orgList, (n) => n.乗務員売上 ?? 0),
      前年実績: _.sumBy(orgList, (n) => n.前年実績 ?? 0),
    }
  } else {
    const 対象部所 = orgList.find((d) => d.部所コード === 部所コード)

    集計Obj = {
      予算額: 対象部所?.予算額 ?? 0,
      当年実績: 対象部所?.当年実績 ?? 0,
      乗務員売上: 対象部所?.乗務員売上 ?? 0,
      前年実績: 対象部所?.前年実績 ?? 0,
    }
  }

  集計Obj.達成率 = 集計Obj.予算額
    ? new Decimal(集計Obj.当年実績).div(集計Obj.予算額).toNumber()
    : 0
  集計Obj.前年比 = 集計Obj.前年実績
    ? new Decimal(集計Obj.当年実績).div(集計Obj.前年実績).toNumber()
    : 0

  return 集計Obj
}

/**
 * 部所売上額（TOP画面）
 */
const BusyoUriagegaku = React.memo(() => {
  //#region [state]
  const [searchStart, setSearchStart] = useState(false)
  const [comboBoxDataInitialized, setComboBoxDataInitialized] = useState(false)
  const loginUserInfo = useSelector(
    (state: RootState) => state.user.LoginUserInfo
  )

  const [年月, set年月] = useState<string>()
  const [部所売上集計, set部所売上集計] = useState<T部所売上額[]>()

  // 部所
  const [部所コード, set部所コード] = useState<
    T部所マスタ["部所コード"] | null
  >(null)
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()

  const [部所ComboBox, set部所ComboBox] = useState<TWijmoComboBox<
    string,
    T部所マスタ
  > | null>(null)
  const [部所isLoadEnded, set部所isLoadEnded] = useState<boolean>(false)

  const searchFunction = useCallback(async (condition: TLoginUserInfo) => {
    // 運行部所でも全部所確認を行う（付替えをするため）ため、全部所の売上を取得
    const 部所売上額Res = await new DashboardService().getBusyoUriagegaku({})
    set部所売上集計(部所売上額Res?.data)
    set年月(
      部所売上額Res?.data[0]
        ? dayjs(`${部所売上額Res?.data[0].年月}01`).format(
            "予実年月:YYYY年MM月"
          )
        : ""
    )
    setSearchStart(false)
  }, [])
  //#endregion

  //#region [effect]

  useEffect(() => {
    Promise.all([new BusyoService().getList({})]).then(([部所ListRes]) => {
      set部所ItemSource(部所ListRes.data)
      setComboBoxDataInitialized(true)
    })
  }, [])

  useEffect(() => {
    if (!comboBoxDataInitialized || !部所ComboBox) return
    if (loginUserInfo.運行部所フラグ === 1) {
      set部所コード(loginUserInfo.部所コード)
    }
    setSearchStart(true)
  }, [comboBoxDataInitialized, loginUserInfo, 部所ComboBox])

  //#endregion

  return (
    <div className="w-100">
      <h4 className="topLabel2">
        部所売上額（対月予算）※月初は前月分が表示されます。
      </h4>
      <div className="w-100">
        <div className={"w-13rem text-end"}>
          <ComboBox.Busyo
            placeholder="部所"
            isDisabled={searchStart}
            isLoadEnded={部所isLoadEnded}
            setIsLoadEnded={set部所isLoadEnded}
            isAllSelect={true}
            isRequired={true}
            itemsSource={部所ItemSource}
            selectedValue={部所コード}
            listFilter={(d) => d.運行部所フラグ === 1}
            setSelectedValue={(v) => {
              set部所コード(v)
            }}
            ComboBox={部所ComboBox}
            setComboBox={set部所ComboBox}></ComboBox.Busyo>
        </div>
      </div>
      <TopCategoryOuter
        searchFunction={searchFunction}
        searchStartFlag={searchStart}>
        <div className="w-100 h-100">
          <table className="w-100">
            <tbody>
              <tr>
                <td>
                  {!wjcCore.isNullOrWhiteSpace(年月 ?? "") && (
                    <div className="text-start">{`${年月}`}</div>
                  )}
                  <div>
                    <BusyoUriagegakuGrid
                      busyoUriageGakuList={部所売上集計}
                      busyoCode={部所コード}></BusyoUriagegakuGrid>
                  </div>
                </td>
                <td>
                  <div>
                    <BusyoUriagegakuGage
                      busyoUriageGakuList={部所売上集計}
                      busyoCode={部所コード}></BusyoUriagegakuGage>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </TopCategoryOuter>
    </div>
  )
})

export default BusyoUriagegaku
